import React from "react";
import './styles/Top.css';
import Carousel from "./Carousel/Carousel";
import MainService from "../components/MainService";

const Top = () => {
  return (
    <>
      <Carousel />
      <main>
        <section className="content">
          <MainService />
        </section>
      </main>
    </>
  )
}

export default Top;